// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconLbtc } from "../../../icons/full/build/icon-lbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const LbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconLbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  LbtcIcon.displayName = 'LbtcIcon';
}

export default LbtcIcon;